import React, { useState, useEffect, useRef } from 'react';
import { get, post, put } from '../../services/apiController';
import { TABLE_DEFAULT_LIMIT, DEBOUNCE_DELAY } from '../../util/constant';
import { Table, Row, Col, Form, Button } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PaginationInPage from '../Pagination';
import useDebounce from '../useDebounce';
import { FaSave } from 'react-icons/fa';
import ExcelDownloadButton from '../../components/atoms/ExcelDownloadButton';
import { getStoredData, get_auth_key } from '../../util';
import Breadcrumb from "../../components/Breadcrumb";

const Requirements = () => {
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [requirementList, setRequirementList] = useState([]);
  const [festivalList, setFestivalList] = useState([]);
  const [festivalDateList, setFestivalDateList] = useState([]);
  const [locationList, setLocations] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [role, setRole] = useState('');
  const clickToDownload = useRef(null);

  const [state, setState] = useState({
    companyId: '',
    locationType: 'outlet',
    locationId: '',
    festivalId: '',
    festivalDateId: '',
    productId: '',
  });

  const handleChange = (e, categoryName, productId) => {
    e.preventDefault();
    const { name, value } = e.target;
    setRequirementList((prevData) => ({
      ...prevData,
      [categoryName]: prevData[categoryName].map((product) => {
        if (product.id === productId) {
          return {
            ...product,
            [name]: value,
            festProductId: productId,
            locationId: +state.locationId,
            festivalDateId: +state.festivalDateId,
          };
        }
        return product;
      }),
    }));
  };

  useEffect(() => {
    const { companyId, locationId, role } = JSON.parse(getStoredData(get_auth_key()));
    const newState = {
      ...state,
      companyId,
    };
    if (locationId && locationId.length > 0) {
      const loggedInUserLocation = locationList.filter((item) => item.id === locationId[0]);
      newState['locationType'] = loggedInUserLocation[0]?.type;
      newState['locationId'] = locationId[0];
    }
    setState(newState);
    setRole(role);
  }, [locationList]);

  const handleSubmit = async () => {
    try {
      const data = Object.values(requirementList).flat();
      put(data, '/fest/requirements/')
        .then((res) => {
          toast.success(res.data.message);
          getRequirements();
        })
        .catch((err) => toast.error(err?.response?.data?.data?.message) || 'Something went wrong');
    } catch (err) {
      toast.error(err.response.data.message || err.response.data.data.message || err.message, { autoClose: 2000 });
    }
  };

  function getRequirements(action = '') {
    try {
      if (state.companyId && state.locationType && state.locationId && state.festivalId && state.festivalDateId) {
        if (action === 'download') {
          get(
            `/fest/requirements/?page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}&&companyId=${state.companyId}&locationType=${state.locationType}&locationId=${state.locationId}&festivalId=${state.festivalId}&festivalDateId=${state.festivalDateId}&action=download`
          ).then((response) => {
            clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${response.data.filePath}`;
            setTimeout(() => {
              clickToDownload.current.click();
            }, 500);
          });
        } else {
          get(
            `/fest/requirements/?page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}&&companyId=${state.companyId}&locationType=${state.locationType}&locationId=${state.locationId}&festivalId=${state.festivalId}&festivalDateId=${state.festivalDateId}`
          ).then((response) => {
            const data = response?.data;
            const categorizedData = {};
            data.forEach((item) => {
              const { categoryName } = item;
              if (!categorizedData[categoryName]) {
                categorizedData[categoryName] = [];
              }
              categorizedData[categoryName].push(item);
            });
            setRequirementList(categorizedData);
            setTotalRecords(response?.data.length);
          });
        }
      }
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message);
    }
  }

  useDebounce(
    () => {
      if (currentPage !== 1) {
        setCurrentPage(1);
      } else {
        getRequirements();
      }
    },
    [],
    DEBOUNCE_DELAY
  );

  useEffect(() => {
    getRequirements();
    getCompanies();
    getFestivals();
    getLocations();
  }, []);

  useEffect(() => {
    if (state.companyId && state.locationType && state.locationId && state.festivalId && state.festivalDateId) {
      getRequirements();
    } else {
      setRequirementList([]);
      setTotalRecords(0);
    }
  }, [state]);

  const getFestivals = () => {
    try {
      get(`/fest/festival/?page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}`).then((response) => {
        setFestivalList(response?.data?.rows);
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message);
    }
  };

  const getFestivalDates = (id) => {
    try {
      get(`/fest/festival-dates/?id=${id}page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}`).then((response) => {
        setFestivalDateList(response?.data?.rows[0]);
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message);
    }
  };

  function getCompanies() {
    try {
      get(`/companies`).then((response) => {
        setCompanyList(response.data.rows);
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || 'something went wrong');
    }
  }

  const getLocations = () => {
    try {
      get(`/branches`).then((response) => {
        setLocations(response.data.rows);
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  };

  let rowNumber = 1;

  return (
    <>
      <ToastContainer />
      <Breadcrumb navigation={[{link: "#", title: "Festival"}, {link: "#", title: "Requirements"}]} />
      <div className="card custom_card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <div className="">
            <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
              Requirements | {totalRecords ?? 0}
            </h4>
          </div>
          <div className="filters">
            <div className="filters-row">
              <Form.Select
                style={{ width: '200px', marginRight: '20px' }}
                required
                name="companyId"
                value={state.companyId}
                disabled={true}
                onChange={(e) => {
                  setState({
                    ...state,
                    companyId: e.target.value,
                    locationType: '',
                    locationId: '',
                  });
                }}
                aria-label="Floating label select example"
                className="form-select"
              >
                <option value="">Select Company</option>
                {companyList.map((company) => {
                  return (
                    <option key={company?.id} value={company?.id}>
                      {company?.name}
                    </option>
                  );
                })}
              </Form.Select>
              <Form.Select
                style={{ width: '200px', marginRight: '20px' }}
                required
                name="locationType"
                value={state.locationType}
                onChange={(e) => {
                  setState({ ...state, locationType: e.target.value, locationId: '' });
                }}
                aria-label="Floating label select example"
                className="form-select"
                disabled={true}
              >
                <option value="">Select Location Type</option>
                <option value="outlet">Outlet</option>
                <option value="staff-room">Staff Room</option>
              </Form.Select>
              <Form.Select
                style={{ width: '200px' }}
                required
                name="locationId"
                value={state.locationId}
                onChange={(e) => setState({ ...state, locationId: e.target.value })}
                aria-label="Floating label select example"
                className="form-select"
                disabled={role === 'festival-manager'}
              >
                <option value="">Select Location</option>
                {locationList
                  .filter((item) => {
                    return item?.type === state.locationType && item?.companyId === parseInt(state?.companyId);
                  })
                  .map((item) => {
                    return (
                      <option key={item?.id} value={item?.id}>
                        {item?.name}
                      </option>
                    );
                  })}
              </Form.Select>
            </div>
            <div className="filters-row mt-2">
              <Form.Select
                required
                style={{ width: '200px', marginRight: '20px' }}
                name="festivalId"
                value={state.festivalId}
                onChange={(e) => {
                  setState({ ...state, festivalId: e.target.value, festivalDateId: '' });
                  getFestivalDates(e.target.value);
                }}
                aria-label="Floating label select example"
                className="form-select"
              >
                <option value="">Select Festival</option>
                {festivalList.map((item, index) => (
                  <option key={index} value={item?.id}>
                    {item?.name} - {item?.year}
                  </option>
                ))}
              </Form.Select>
              <Form.Select
                style={{ width: '200px', marginRight: '20px' }}
                required
                name="festivalDateId"
                value={state.festivalDateId}
                onChange={(e) => setState({ ...state, festivalDateId: e.target.value })}
                aria-label="Floating label select example"
                className="form-select"
              >
                <option value="">Select Festival Date</option>
                {festivalDateList?.FestivalDates?.map((item, index) => (
                  <option key={index} value={item?.id}>
                    {item?.date}
                  </option>
                ))}
              </Form.Select>
              <ExcelDownloadButton title="Download" onClick={() => getRequirements('download')} />
              <a ref={clickToDownload} href="" target="_blank" className="hiddenItem">
                HiddenClick
              </a>
            </div>
          </div>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped bordered>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Category</th>
                    <th>Product</th>
                    <th>Requirement</th>
                    <th>Comments</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(requirementList).map((category, categoryIndex) => {
                    return requirementList[category].map((item, index) => (
                      <tr key={item?.id}>
                        <td>{rowNumber++}</td>
                        {index === 0 && <td rowSpan={requirementList[category].length}>{category}</td>}
                        <td>{item?.productName}</td>
                        <td>
                          <input
                            value={item?.requirement ?? ''}
                            name="requirement"
                            onChange={(e) => handleChange(e, category, item?.id)}
                            type="number"
                            placeholder="Enter Requirement"
                          />
                        </td>
                        <td>
                          <input
                            value={item?.comment ?? ''}
                            name="comment"
                            onChange={(e) => handleChange(e, category, item?.id)}
                            type="text"
                            placeholder="Comments"
                          />
                        </td>
                        {categoryIndex === 0 && index === 0 && (
                          <td rowSpan={totalRecords} className="actions text-center">
                            <Button onClick={handleSubmit} type="submit" className="btn-sm primary-btn-bg">
                              SAVE
                            </Button>
                          </td>
                        )}
                      </tr>
                    ));
                  })}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Requirements;
